import { Pipe, PipeTransform } from '@angular/core';
import { TabloMember } from '@ui/tablo-generator/types';

@Pipe({
    name: 'isPhotoTaken',
    standalone: false
})
export class IsPhotoTakenPipe implements PipeTransform {
  transform(
    photoId: string,
    config: Record<
      string,
      { x: number; y: number; photoId: string; groupId: string }
    >,
    members: TabloMember[],
  ): boolean {
    if (typeof photoId !== 'string') {
      return false;
    }
    const memberIds = members.map((v) => v.tabloMemberId);
    return Object.entries(config)
      .filter(([tabloMemberId]) => memberIds.includes(tabloMemberId))
      .some(([tabloMemberId, v]) => v.photoId === photoId);
  }
}
